export enum LDFeatureFlags {
    DisplayMode = 'DisplayMode',
    FavouritesNavigationMenuPosition = 'favourites-navigation-menu-position',
    ReuseSelections = 'MyBetsReuseSelections',
}
export const LD_FEATURE_FLAG_STORAGE_KEY = 'LdFeatureFlags';
export const LD_FEATURE_FLAGS = [LDFeatureFlags.DisplayMode];
